import { Link } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import styled from 'styled-components';

import { fonts } from '../lib/constants';

const Title = styled.div({
  fontFamily: fonts.bold,
  marginBottom: 10,
  fontSize: 14,
});
const Eyebrow = styled.div({
  fontSize: 14,
  textDecoration: 'underline',
  marginBottom: 5,
});
const StyledImg = styled(Img)({
  width: '100%',
});
const Item = styled(Link)({
  display: 'grid',
  gridTemplateColumns: '160px 1fr',
  columnGap: 20,
  marginBottom: 25,
});

export default function FeaturedCard({ title, image, eyebrow, to }) {
  return (
    <Item to={to}>
      <StyledImg alt={title} sizes={image.sizes} />
      <div>
        <Eyebrow>{eyebrow}</Eyebrow>
        <Title>{title}</Title>
      </div>
    </Item>
  );
}
